module.exports = __webpack_public_path__ + "static/media/location-pin.088ccd55.png";